<template>
    <img v-if="id === 0" src="@/assets/images/events/0.svg" />
    <img v-else-if="id === 1" src="@/assets/images/events/1.svg" />
    <img v-else-if="id === 2" src="@/assets/images/events/2.svg" />
    <img v-else-if="id === 3" src="@/assets/images/events/3.svg" />
    <img v-else-if="id === 4" src="@/assets/images/events/4.svg" />
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                required: true
            }
        }
    }
</script>
